import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SectionHeader } from "./SectionHeader";
import { useT } from "@/lib/i18n";

export const FAQ = () => {
  const { t } = useT();
  return (
    <section id="faq" className="section-y" aria-labelledby="faq-title">
      <div className="container-x max-w-4xl">
        <SectionHeader kicker={t.faq.kicker} title={t.faq.title} subtitle={t.faq.subtitle} />

        <Accordion type="single" collapsible className="mt-8 space-y-3" data-testid="faq-accordion">
          {t.faq.items.map((f, idx) => (
            <AccordionItem
              key={idx}
              value={`item-${idx}`}
              className="rounded-xl border border-border bg-card px-4 shadow-soft data-[state=open]:shadow-lifted"
              data-testid={`faq-item-${idx}`}
            >
              <AccordionTrigger className="text-left text-base font-medium text-foreground hover:no-underline py-4" data-testid={`faq-trigger-${idx}`}>
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-foreground/80 leading-relaxed pb-4">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
